export default __webpack_public_path__ + "static/media/despoilthesoul.2c11abf9.png";